<template>
  <div v-on:click="goActorPage()"
    class="dorm-card"
    :class="[{
        premium : actor.is_advert,
        male : actor.dorm_type_id === 1,
        female : actor.dorm_type_id === 2
      }]">
    <div class="dorm-card__top">
      <!--"dorm-card-badge" element only seen when there ise 1.order ad.-->
      <div class="dorm-card-badge" v-if="actor.is_advert">
        
        <div class="badge_in">
          <div class="img_wrp">
            <img src="@/assets/img/star-icon-white.svg" alt="" class="img-fluid">
          </div>
          <span>Popular</span>
        </div>

        <!-- <div class="button red icon-left" :class="[{
        premium : dorm.is_advert,
        male : dorm.dorm_type_id === 1,
        female : dorm.dorm_type_id === 2
      }]">
          <span class="button__wrp">
            <span class="button__icon">
              
              <img src="@/assets/img/star-icon-white.svg" alt="" class="img-fluid" width="20">
              
            </span>
            <span class="button__txt">
                Popüler Tercih
            </span>
          </span>
        </div> -->
      </div>
      <img :src="'http://image.tmdb.org/t/p/w185/' + actor.profile_path" alt="" class="dorm-card__img">
      <div class="dorm-card__overlay">
      <v-button
        class="dorm-card__button"
        title="Inspect"
      />
      </div>
    </div>
    <div class="dorm-card__cnt">
      <div class="dorm-card__content">
        <div class="dorm-card__title">
          <small v-if="!actor.branch_count || !actor.center_slug">Popularity: {{ actor.popularity }}</small>
          <!-- <small v-if="actor.known_for_department">{{ actor.known_for_department }}</small> -->
          <span class="dorm-card__title-main" :title="actor.known_for_department">
            <strong>{{ actor.character}}{{ actor.name }}</strong>
          </span>
<!--           <span class="dorm-card__title-main" :title="actor.overview" v-if="actor.known_for">
            <strong>Known For </strong>
          </span>
          <span class="dorm-card__title-main" :title="actor.overview" v-if="actor.known_for[0]">
          {{ actor.known_for[0].name}}{{ actor.known_for[0].original_title}}
            <br v-if="actor.known_for[1]">{{ actor.known_for[1].name}}{{ actor.known_for[1].original_title}}
            <br v-if="actor.known_for[2]">{{ actor.known_for[2].name}}{{ actor.known_for[2].original_title}}
          </span>  -->                 
        </div>
        <!--<div class="dorm-card-price">-->
        <!--<div class="dorm-card-price__title">-->
        <!--{{ dorm.price }} TL-->
        <!--</div>-->
        <!--<div class="dorm-card-price__txt">-->
        <!--‘den başlayan<br>oda fiyatları-->
        <!--</div>-->
        <!--</div>-->
      </div>
      <div class="dorm-card__bottom">
        <div class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-branches"/>
          </div>
          <div class="btn-txt">
            {{ actor.popularity }} Popularity
          </div>
        </div>        
        <div class="dorm-card__inf" v-if="!actor.branch_count || !actor.center_slug">
          <div class="icon-font">
            <svg-icon type="icon-user"/>
          </div>
          <div class="btn-txt">
            {{ actor.vote_average }} Vote
          </div>
        </div>

        <div v-if="actor.adult" class="dorm-card__inf" >
          <div class="icon-font">
            <svg-icon type="icon-food"/>
          </div>
          <div class="btn-txt">
            {{ actor.adult }} Adult
          </div>
        </div>      
        <div v-else-if="!actor.video && actor.is_wifi && !actor.branch_count" class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-wifi"/>
          </div>
          <div class="btn-txt">
            Yes
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonCard',
  data () {
    return {
      branchnumber: '',
      branchNames: '',
      distinctCities: '',
      movies: '',
    }
  },
  props: {
    actor: Object
  },
  methods: {
        string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },  
    mobileCheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
},
    goActorPage () {
      const slug = this.string_to_slug(this.actor.name)
      const route = { name: 'PersonDetail', params: { slug: slug, id:this.actor.id } }
      this.$router.push(route)
    }
  },
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/components/dorm-card";
  .mywashed {
    background-blend-mode: lighten
  }
</style>
